import React from 'react';
import { Button, Typography } from '@mui/material';
import { BaseDialog } from './BaseDialog.tsx';

interface AlertDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  confirmText?: string;
}

/**
 * Діалог для відображення повідомлення
 * @param open - чи відкрите вікно
 * @param onClose - функція для закриття вікна
 * @param title - заголовок вікна
 * @param message - текст-повідомлення
 * @param confirmText - текст для кнопки підтвердження (за замовчуванням "OK")
 */
export const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  onClose,
  title,
  message,
  confirmText = 'OK',
}) => {
  const actions = (
    <Button onClick={onClose} color="primary" variant="contained">
      {confirmText}
    </Button>
  );

  return (
    <BaseDialog
      open={open}
      onClose={onClose}
      title={title}
      actions={actions}
    >
      <Typography whiteSpace="pre-wrap">{message}</Typography>
    </BaseDialog>
  );
};
